;(function () {
	let swiper

	const initReviewsCarousel = () => {
		$('.ov-reviews-carousel-section').each(function () {
			const id = $(this).attr('id')
			const box = $(this).find('.ov-reviews-carousel')
			const autoplay = box.data('autoplay')
			const stopAutoplay = box.data('stop-autoplay')
			const delay = box.data('delay') * 1000
			const speed = box.data('speed') * 1000
			const blockCount = box.data('block-count')

			if (blockCount < 2) {
				return
			}

			let autoplayParm = {}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				}
			}

			const swiperParms = {
				speed: speed,
				slidesPerView: 'auto',
				// No spaceBetween: gap is CSS margin-right on the slide, responsive
				// per breakpoint (1.6rem mobile, 4rem desktop) — Swiper measures the
				// real rendered slide width (incl. margin) in 'auto' mode.
				loop: true,
				keyboard: true,
				grabCursor: true,
				simulateTouch: true,
				touchRatio: 1,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			}

			if (swiper) {
				swiper.destroy()
			}

			swiper = new Swiper(`#${id} .ov-reviews-carousel__swiper`, swiperParms)

			// Re-measure after web fonts finish swapping in — a font swap after
			// Swiper's initial layout can change card heights and leave stale
			// slide/nav positioning behind.
			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(function () {
					if (swiper && !swiper.destroyed) {
						swiper.update()
					}
				})
			}
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initReviewsCarousel()
		document.addEventListener('shopify:section:load', function () {
			initReviewsCarousel()
		})
	})
})()
